import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "payment-item__sale" };
import { computed } from 'vue';
import PaymentItem from "./PaymentItem.vue";
import { PaymentItemProps } from "./utils";
import Price from "../../Price.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'Cash',
    props: /*@__PURE__*/ _mergeModels({
        ...PaymentItemProps,
        config: {
            type: Object,
            required: true,
        },
    }, {
        "modelValue": {},
        "modelModifiers": {},
    }),
    emits: ["update:modelValue"],
    setup(__props) {
        const props = __props;
        const disabled = computed(() => !props.config.available || props.config.personalBan || props.config.banned || !props.config.availableForLocation);
        const value = _useModel(__props, "modelValue");
        const discount = computed(() => props.config.discount);
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(PaymentItem, {
                system: _ctx.system,
                disabled: disabled.value,
                modelValue: value.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((value).value = $event))
            }, _createSlots({ _: 2 /* DYNAMIC */ }, [
                (!__props.config.available)
                    ? {
                        name: "message",
                        fn: _withCtx(() => [
                            _cache[1] || (_cache[1] = _createTextVNode("Доступно при доставке курьером", -1 /* CACHED */))
                        ]),
                        key: "0"
                    }
                    : undefined,
                (__props.config.available && disabled.value)
                    ? {
                        name: "message",
                        fn: _withCtx(() => [
                            (!__props.config.availableForLocation)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode("\n        Недоступно при заказе в данный населённый пункт\n      ")
                                ], 64 /* STABLE_FRAGMENT */))
                                : (__props.config.personalBan)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _cache[2] || (_cache[2] = _createTextVNode("\n        Оплата наличными для вас не доступна, так как вы нарушили правила работы магазина.", -1 /* CACHED */)),
                                        _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                                        _cache[4] || (_cache[4] = _createTextVNode("\n        Если у вас есть вопросы вы можете связаться с нами по тел. ", -1 /* CACHED */)),
                                        _cache[5] || (_cache[5] = _createElementVNode("a", { href: "tel:88002503534" }, "8 800 250-35-34", -1 /* CACHED */))
                                    ], 64 /* STABLE_FRAGMENT */))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                        _createTextVNode("Оплата наличными будет возможна после первого выполненного заказа")
                                    ], 64 /* STABLE_FRAGMENT */))
                        ]),
                        key: "1"
                    }
                    : undefined,
                ((!disabled.value || !__props.config.available) && __props.config.availableForLocation && discount.value)
                    ? {
                        name: "suffix",
                        fn: _withCtx(() => [
                            _createElementVNode("div", _hoisted_1, [
                                _cache[6] || (_cache[6] = _createTextVNode("Скидка ", -1 /* CACHED */)),
                                _createElementVNode("strong", null, [
                                    _createVNode(Price, { amount: discount.value }, null, 8 /* PROPS */, ["amount"])
                                ])
                            ])
                        ]),
                        key: "2"
                    }
                    : undefined
            ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["system", "disabled", "modelValue"]));
        };
    }
});
